import { memo } from 'react';

import { Heading, Text } from '@/components/core';
import { TriggerHeader } from '@/components/flow';
import { N8NLogo } from '@/components/logos';

export type N8NTriggerNodeContentProps = {
  agentId: string;
  actionId: string;
};

const IN8NTriggerNodeContent = ({ agentId, actionId }: N8NTriggerNodeContentProps) => {
  return (
    <>
      <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
        <TriggerHeader agentId={agentId} actionId={actionId}>
          <N8NLogo size="lg" />
          <Heading size="lg">Import from n8n</Heading>
        </TriggerHeader>
      </div>

      <div className="flex flex-col gap-2 pt-2">
        <Text>When a document is submitted through n8n.</Text>
      </div>
    </>
  );
};

export const N8NTriggerNodeContent = memo(IN8NTriggerNodeContent) as typeof IN8NTriggerNodeContent;
